import React from "react"
import Layout from "../components/layout"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { GatsbySeo } from "gatsby-plugin-next-seo"
import { BLOCKS } from "@contentful/rich-text-types"
import RichTextImageBlock from "../components/richTextImageBlock"
import LatestProjects from "../components/latestProjects"
// import { StaticImage } from "gatsby-plugin-image"
import { BlogPostJsonLd } from "gatsby-plugin-next-seo"

const Project = ({ data }) => {
  const {
    amountCarbonOffsetPerAnum,
    amountEnergyGeneratedPerAnum,
    title,
    image,
    projectContent,
    location,
    projectExcerpt,
    slug,
  } = data.contentfulProject

  // parse the contents of the rich-text data
  const document = JSON.parse(projectContent.raw)

  // functions and options for dealing with images used in the rich-text area
  const getEntryWithId = entryId =>
    projectContent.references.filter(ref => ref.contentful_id === entryId)

  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: ({ data }) => {
        return <RichTextImageBlock data={getEntryWithId(data.target.sys.id)} />
      },
    },
  }

  return (
    <>
      <BlogPostJsonLd
        url={`https://www.oneplanetassociates.com/${slug}`}
        title={title}
        images={[
          {
            url: `https:${image.resize.src}`,
            width: image.resize.width,
            height: image.resize.height,
            alt: image.title,
          },
        ]}
        authorName="Gareth Davies"
        publisherName="One Planet Associates Ltd"
        description={projectExcerpt.projectExcerpt}
      />
      <GatsbySeo
        title={`OPA - ${title}`}
        description={projectExcerpt.projectExcerpt}
        openGraph={{
          images: [
            {
              url: image.resize.src,
              width: image.resize.width,
              height: image.resize.height,
              alt: image.title,
            },
          ],
        }}
      />
      <Layout>
        <section className="page-wrapper">
          <div className={`pt-32`}>
            <div className="pb-32 bg-cream">
              <div className="relative">
                <div className="mb-6 h-72 md:h-96">
                  <GatsbyImage
                    image={getImage(image)}
                    alt={image.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="contour-overlay flex items-end py-4 md:py-6 md:inset-0 md:absolute ">
                  <div className="px-4 md:max-w-5xl md:mx-auto w-full">
                    <h1 className="text-3xl lg:text-4xl text-navy md:text-white lg:pt-6">
                      {title}
                    </h1>
                    <div className="mb-8 md:mb-0 md:flex md:gap-x-8 md:gap-y-4 md:flex-wrap">
                      {amountCarbonOffsetPerAnum ? (
                        <div className="flex items-center mb-4 md:mb-0 md:flex-none">
                          <svg
                            fill="currentColor"
                            width="800px"
                            height="800px"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                            className={`w-12 h-12 mr-4 md:mr-2 flex-none text-navy md:text-white`}
                          >
                            <g id="Renewable_energy_solar">
                              <path d="M385.33,251.05c0-16.2-26-27.11-31.82-41.2-6.05-14.6,4.37-40.63-6.63-51.64s-37-.57-51.64-6.63c-14.08-5.84-25-31.82-41.19-31.82s-27.11,26-41.2,31.82c-14.6,6.06-40.63-4.37-51.64,6.63s-.58,37-6.63,51.64c-5.84,14.09-31.82,25-31.82,41.2s26,27.11,31.82,41.19c6,14.6-4.37,40.64,6.63,51.64s37,.58,51.64,6.64c14.09,5.84,25,31.81,41.2,31.81s27.11-26,41.19-31.81c14.6-6.06,40.64,4.37,51.64-6.64s.58-37,6.63-51.64C359.35,278.16,385.33,267.25,385.33,251.05Zm-131.28,73.1a73.11,73.11,0,1,1,73.1-73.1A73.1,73.1,0,0,1,254.05,324.15Z" />
                              <path d="M280.81,243.67H267.09a4.59,4.59,0,0,1-4.29-6.23l11.54-30.38a4.6,4.6,0,0,0-4.3-6.23H240.2a4.59,4.59,0,0,0-4.5,3.64l-12.92,60.74a4.59,4.59,0,0,0,4.5,5.55h19.48a4.6,4.6,0,0,1,4.52,5.47l-3.84,20a5,5,0,0,0,9.22,3.42l28.14-49.05A4.6,4.6,0,0,0,280.81,243.67Z" />
                              <path d="M404.15,404.18A210.8,210.8,0,0,0,450,180.41C407.9,72.21,285.61,18.43,177.4,60.54l6.53,16.78c99-38.51,210.79,10.66,249.3,109.62a192.77,192.77,0,0,1-42,204.68l-12.8-12.47a9.51,9.51,0,0,0-16.15,6.94l.48,33.89a9.51,9.51,0,0,0,9.62,9.37l33.89-.4a9.51,9.51,0,0,0,6.52-16.32Z" />
                              <path d="M181.85,431a192.44,192.44,0,0,1-60-311l11.34,11a9.51,9.51,0,0,0,16.15-6.94l-.48-33.89a9.49,9.49,0,0,0-9.62-9.37l-33.89.4A9.51,9.51,0,0,0,98.8,97.58l10.13,9.87A210.53,210.53,0,0,0,335.69,451.07l-6.52-16.77A191.29,191.29,0,0,1,181.85,431Z" />
                            </g>
                          </svg>
                          <div>
                            <h6 className="mb-0 md:text-white">
                              Installed Capacity
                            </h6>
                            <p className="mb-0 text-lg md:text-white">
                              {amountCarbonOffsetPerAnum}
                            </p>
                          </div>
                        </div>
                      ) : (
                        ``
                      )}
                      {amountEnergyGeneratedPerAnum > 0 ? (
                        <div className="flex items-center mb-4 md:mb-0 md:flex-none md:text-white">
                          <svg
                            className={`w-12 h-8 md:h-12 md:w-8 mr-4 md:mr-2 flex-none text-navy md:text-white`}
                            fill="currentColor"
                            width="800px"
                            height="800px"
                            viewBox="0 0 32 32"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M31.772 16.043l-15.012-15.724c-0.189-0.197-0.449-0.307-0.721-0.307s-0.533 0.111-0.722 0.307l-15.089 15.724c-0.383 0.398-0.369 1.031 0.029 1.414 0.399 0.382 1.031 0.371 1.414-0.029l1.344-1.401v14.963c0 0.552 0.448 1 1 1h6.986c0.551 0 0.998-0.445 1-0.997l0.031-9.989h7.969v9.986c0 0.552 0.448 1 1 1h6.983c0.552 0 1-0.448 1-1v-14.968l1.343 1.407c0.197 0.204 0.459 0.308 0.722 0.308 0.249 0 0.499-0.092 0.692-0.279 0.398-0.382 0.411-1.015 0.029-1.413zM26.985 14.213v15.776h-4.983v-9.986c0-0.552-0.448-1-1-1h-9.965c-0.551 0-0.998 0.445-1 0.997l-0.031 9.989h-4.989v-15.777c0-0.082-0.013-0.162-0.032-0.239l11.055-11.52 10.982 11.507c-0.021 0.081-0.036 0.165-0.036 0.252z"></path>
                          </svg>
                          <div>
                            <h6 className="mb-0 md:text-white">
                              Homes Powered Per Annum
                            </h6>
                            <p className="mb-0 text-lg md:text-white">
                              {amountEnergyGeneratedPerAnum}&nbsp;
                            </p>
                          </div>
                        </div>
                      ) : (
                        ``
                      )}
                      {location && (
                        <div className="flex items-center mb-4 md:mb-0 md:flex-none">
                          <svg
                            width="800px"
                            height="800px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            className={`w-12 h-10 mr-4 md:mr-2 flex-none text-navy md:text-white`}
                          >
                            <path
                              d="M13.29 14.667L11 16.097V3.81l3-1.5v5.968a6.182 6.182 0 0 1 1-1.104V2.307l3.024 1.503-.003 1.974A6.275 6.275 0 0 1 19 5.7l.02.001.005-2.51L14.5.94l-4 2-4-2L2 3.191V17.9l4.5-2.811 4 2.5 3.15-1.968q-.202-.485-.36-.955zM6 14.223l-3.001 1.876-.023-12.29L6 2.308zm4 1.875l-3-1.875V2.309l3 1.5zM19 7a4.96 4.96 0 0 0-4.9 5.086c0 2.807 2.678 6.606 4.9 10.914 2.222-4.308 4.9-8.107 4.9-10.914A4.96 4.96 0 0 0 19 7zm0 13.877c-.298-.543-.598-1.077-.89-1.6-1.548-2.762-3.01-5.37-3.01-7.191a3.905 3.905 0 1 1 7.8 0c0 1.82-1.462 4.429-3.01 7.19-.292.524-.592 1.058-.89 1.601zm0-11.043A2.166 2.166 0 1 0 21.13 12 2.147 2.147 0 0 0 19 9.834zm0 3.332A1.167 1.167 0 1 1 20.13 12 1.15 1.15 0 0 1 19 13.166z"
                              fill="currentColor"
                            />
                            <path fill="none" d="M0 0h24v24H0z" />
                          </svg>
                          <div>
                            <h6 className="mb-0 md:text-white ">Location</h6>
                            <p className="mb-0 text-lg md:text-white">
                              {location}&nbsp;
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-4 py-2 md:py-12">
                <div className="mx-auto md:max-w-3xl">
                  {documentToReactComponents(document, options)}
                </div>
              </div>
            </div>
          </div>
        </section>
        <LatestProjects />
      </Layout>
    </>
  )
}

export default Project

export const data = graphql`
  query ($currentPage: String!) {
    contentfulProject(slug: { eq: $currentPage }) {
      id
      title
      location
      amountCarbonOffsetPerAnum
      amountEnergyGeneratedPerAnum
      slug
      image {
        gatsbyImageData(sizes: " 100vw", quality: 70)
        title
        resize(width: 2000) {
          width
          height
          src
        }
      }
      projectContent {
        raw
        references {
          gatsbyImageData
          title
          contentful_id
        }
      }
      projectExcerpt {
        projectExcerpt
      }
    }
  }
`
